module.exports = __webpack_public_path__ + "img/CERTIFICATE_LANDING_PAGE_PQKWVR8973BE.05ea13cb.jpeg";